import {EntityService} from '../EntityService';

export class TemplateInvoiceService extends EntityService {

  static entity = 'app/template-invoice';

  static get(id: string): Promise<any> {
    return this.axios.get(`${this.entity}/${id}`).then(res => res.data);
  }

  static getHtml(id: string): Promise<any> {
    return this.axios.get(`${this.entity}/html/${id}`).then(res => res.data);
  }

  static getImagePreview(id: string): Promise<any> {
    return this.axios.get(`${this.entity}/image-preview/${id}`, {responseType: 'blob'}).then(res => res.data);
  }

}
